import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { observer } from 'mobx-react-lite';
import { Platform } from 'react-native';
import { isPast } from 'date-fns';

import { screens } from './screens';
import {
  HubScreen,
  // MyMusicScreen,
  ProfileScreen,
  SearchScreen,
  TrackFeedbackScreen,
} from '@screens';
import type { TabParamListType } from './types';
import { BottomTabBar } from './components/BottomTabBar';
import { MainHeader, WebHeader } from '@components';
import { IS_MOBILE, IS_WEB } from '@utils';
import { HomeTabNavigator } from './HomeTabNavigator';
import config from '@config';

const BottomTabNavigator =
  createBottomTabNavigator<TabParamListType>();

export const TabNavigator = observer(() => {
  const isShowTrackFeedback =
    isPast(new Date(2023, 11, 31, 23, 59, 59)) ||
    config.ENV !== 'production';

  return (
    <BottomTabNavigator.Navigator
      tabBar={(props) => IS_MOBILE && <BottomTabBar {...props} />}
    >
      <BottomTabNavigator.Screen
        name={screens.HomeTabNavigator}
        component={HomeTabNavigator}
        options={{
          header: () =>
            Platform.select({
              web: (
                <WebHeader
                  activeTabButtonName={screens.HomeTabNavigator}
                />
              ),
              default: <MainHeader />,
            }),
        }}
      />
      {/* <BottomTabNavigator.Screen
      name={screens.MyMusic}
      component={MyMusicScreen}
      options={{
        header: () =>
          Platform.select({
            web: <WebHeader activeTabButtonName={screens.MyMusic} />,
            default: <MainHeader />,
          }),
      }}
    /> */}
      {isShowTrackFeedback && (
        <BottomTabNavigator.Screen
          name={screens.TrackFeedback}
          component={TrackFeedbackScreen}
          options={{
            header: () =>
              Platform.select({
                web: (
                  <WebHeader
                    activeTabButtonName={screens.TrackFeedback}
                  />
                ),
                default: <MainHeader />,
              }),
          }}
        />
      )}
      <BottomTabNavigator.Screen
        name={screens.Search}
        component={SearchScreen}
        options={{
          /**
           * On web need to unmount the screen on blur because we do not use this screen
           * as an ordinary tab screen and we pass params to this screen each time when
           * we navigate to it which requires mounting this screen each time
           */
          unmountOnBlur: IS_WEB,
          header: () =>
            Platform.select({
              web: <WebHeader activeTabButtonName={screens.Search} />,
              default: <MainHeader />,
            }),
        }}
      />
      <BottomTabNavigator.Screen
        name={screens.Hub}
        component={HubScreen}
        options={{
          header: () =>
            Platform.select({
              web: <WebHeader activeTabButtonName={screens.Hub} />,
              default: <MainHeader />,
            }),
        }}
      />
      <BottomTabNavigator.Screen
        name={screens.Profile}
        component={ProfileScreen}
        options={{
          headerShown: IS_WEB,
          header: () => (
            <WebHeader activeTabButtonName={screens.Profile} />
          ),
        }}
      />
    </BottomTabNavigator.Navigator>
  );
});
